import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { stringify } from 'qs';
import { map } from 'rxjs';
import { extractStrapiData } from '../../helpers';
import { StrapiQueryParams, StrapiResponse } from '../../models';
import { MainConfiguration } from '../../models/main-configuration';

@Injectable({ providedIn: 'root' })
export class MainConfigurationService {
  private readonly http = inject(HttpClient);

  private readonly queryParams: StrapiQueryParams = {
    populate: {
      logoLeoch: true,
      drawingConfiguration: true,
    },
  };

  private readonly url = 'api/main-configuration';

  loadConfiguration() {
    return this.http
      .get<
        StrapiResponse<MainConfiguration>
      >(`${this.url}?${stringify(this.queryParams)}`)
      .pipe(map((conf) => extractStrapiData(conf)));
  }
}
